import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Routes, Route } from 'react-router';
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import Root from './Root';
import RiverPage from './Rivers/RiverPage';
import LegalTermsPage from './Pages/LegalTermsPage';
import LegalDataPage from './Pages/LegalDataPage';
import NotFoundErrorPage from './components/NotFoundErrorPage';
import Navigation from './components/Navigation';
import Footer from './components/Footer';

import enTranslations from './locales/en/translation.json';

import 'bootstrap/dist/css/bootstrap.css';
import './App.css'
import ScrollToTop from './components/ScrollToTop.jsx';

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: {
        translation: enTranslations
      }
    },
    lng: "en", // if you're using a language detector, do not define the lng option
    fallbackLng: "en",
    interpolation: {
      escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    }
  });

const queryClient = new QueryClient()

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ScrollToTop />
      <div className="placeholder-glow">
        <div className="page-wrapper">
          <div className="page-wrapper-inner">
            <Navigation />
            <Routes>
              <Route path="/" element={<Root />} />
              <Route path="/rivers/:riverKey" element={<RiverPage />} />
              <Route path="/rivers/:riverKey/map" element={<RiverPage mapOnly={true} />} />
              <Route path="/legal/terms" element={<LegalTermsPage />} />
              <Route path="/legal/data" element={<LegalDataPage />} />
              <Route path="*" element={<NotFoundErrorPage />}
              />
            </Routes>
          </div>
          <Footer />
        </div>
      </div>
    </QueryClientProvider>
  );
}

export default App
